import { createContext } from 'react';

// The multi-asset "universe" for the strategy being edited: an array of
// { symbol, asset_type } for the SECONDARY symbols (the primary is whatever the
// backtest runner targets). Empty => single-symbol strategy, in which case the
// per-node symbol dropdowns hide themselves entirely.
const UniverseContext = createContext([]);

export default UniverseContext;
